import { http } from "@/helpers/http";
// const baseUrl = "https://58dzq8ytqb.execute-api.us-east-1.amazonaws.com/dev/v1";
// const baseUrl = "http://localhost:3000/dev/v1"; // dev

const baseUrl = "/print/v1";

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {
  },

  actions: {
    async printLabels({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.post(baseUrl + "/print-label", payload.req)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async printReceipt({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.post(baseUrl + "/print-receipt", payload.req)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    }

  },
};

